
import Footer from 'app/components/FooterComponent';
import Header from 'app/components/HeaderComponent';
import HeaderImage from 'home/components/HeaderImage';
import Icon from '__common/components/Icon';
import Loader from '__common/components/LoaderComponent';
import React from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions } from '@mui/material';
import { connect } from 'react-redux';
import {
  CLEAR_USER_PREFERENCES,
  DISABLE_ACCOUNT,
  DISABLE_ACCOUNT_CLEAR,
  logOut,
  } from 'actions';

type State = {
  selection: string,
  showConfirmation: boolean,
};

type Props = {
  dispatch: Function,
  disableAccount: disableAccountState,
};

class DisableAccount extends React.Component<Props, State> {
  state = {
    selection: 'yes',
    showConfirmation: false,
  };

  componentWillUnmount() {
    const { dispatch } = this.props;
    dispatch(DISABLE_ACCOUNT_CLEAR());
  }

  openConfirmation = () => {
    this.setState({ showConfirmation: true });
  }

  closeConfirmation = () => {
    this.setState({ showConfirmation: false });
  }

  confirmDisable = () => {
    const { dispatch } = this.props;
    this.closeConfirmation();
    dispatch(DISABLE_ACCOUNT());
  }

  form() {
    const { showConfirmation } = this.state;

    return (
      <>
        <div className="disable-account-form">
          <div className="form-header">
            <h1 className="form-title">DISABLE ACCOUNT</h1>
            <p className="form-subtitle">This action cannot be undone</p>
          </div>

          <div className="form-actions">
            <Button
              variant="contained"
              type="button"
              className="btn-disable"
              onClick={this.openConfirmation}
            >
              Disable Account
            </Button>
          </div>
        </div>

        <Dialog
          open={showConfirmation}
          onClose={this.closeConfirmation}
          className="confirmation-dialog"
        >
          <DialogTitle>Confirm Account Disabling</DialogTitle>
          <DialogContent>
            Are you sure you want to disable your account? This action cannot be undone .
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.closeConfirmation}
              variant="outlined"

            >
              No
            </Button>
            <Button
              onClick={this.confirmDisable}
              variant="contained"
              color="error"
            >
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      </>
    );
  }

  successfullyDisabled = () => {
    const { dispatch } = this.props;

    setTimeout(() => {
      dispatch(CLEAR_USER_PREFERENCES());
      dispatch(logOut());
    },         2000);

    return (
      <>
      Your account has been disabled
    </>
    );
  }
  content = () => {
    const { disableAccount: { error, sending, success } } = this.props;

    if (error) {
      return(<div>Cannot disable account</div>);
    }

    if (sending) {
      return(<Loader />);
    }

    if (success) {
      return (
        this.successfullyDisabled()
      );
    }

    return this.form();
  }

  render() {
    return (
      <div className="app-content disable-account">
        <Header />
        <HeaderImage content={this.content()} />
        <Footer />
      </div>
    );
  }
}

function mapStateToProps(state: appState) {
  return {
    disableAccount: state.disableAccount,
  };
}

export default connect(mapStateToProps)(DisableAccount);
